import { gql } from "@apollo/client";

export const QR_LIST_TRIP_PUBLICATION_SUMMARY = gql`
  query GetPublicationSummaryList(
    $paginationParams: BaseCollection!
    $establishmentIds: [String!]
    $publicationIds: [String!]
    $destination: String
    $startDate: DateTime
    $endDate: DateTime
    $adultTravelers: Float
    $childTravelers: Float
    $babiesTravelers: Float
    $maxPrice: Float
    $minPrice: Float
  ) {
    QR_LIST_TRIP_PUBLICATION_SUMMARY(
      paginationParams: $paginationParams
      establishmentIds: $establishmentIds
      publicationIds: $publicationIds
      destination: $destination
      startDate: $startDate
      endDate: $endDate
      adultTravelers: $adultTravelers
      childTravelers: $childTravelers
      babiesTravelers: $babiesTravelers
      maxPrice: $maxPrice
      minPrice: $minPrice
    ) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        totalElements
        totalPages
        currentPage
        content {
          id
          tripId
          tripDateId
          establishmentId
          picture
          country
          city
          locations
          title
          smallDescription
          nbNights
          startDate
          endDate
          price {
            value
            currency
          }
          globalMark
          nbOfopinion
          isFavorite
          favoriteId
          activities
          options
        }
      }
    }
  }
`;
